import { REGISTER_WEBORDER } from "./actionTypes";

export const registerWebOrder = (payload) => {
  return {
    type: REGISTER_WEBORDER,
    payload,
  };
};
